import { j as r } from "./jsx-runtime-944c88e2.js";
import { Box as f, SimpleGrid as z, Card as A, CardHeader as C, Image as S, CardBody as w, Text as h, Button as T } from "@chakra-ui/react";
import { useState as W } from "react";
import { u as a, T as d } from "./eMyAsurionProvider-d8e4d830.js";
import "@tanstack/react-query";
import "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./features-d3d4bb45.js";
import "./providers-251f5186.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-bf220bf9.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "@emotion/styled";
const ii = ({
  onClickCallback: m,
  children: B,
  cardContent: t,
  actualModel: e,
  cardClickable: g = !0,
  // setting default value to true
  ...j
}) => {
  const [n, y] = W(6), s = "Cards", { data: c } = a(), { theme: b } = c, { colors: p } = b, N = () => {
    y((i) => i + 6);
  }, u = function(i) {
    return i.replace(/\w+/g, function(o) {
      return o.charAt(0).toUpperCase() + o.slice(1);
    });
  };
  return /* @__PURE__ */ r.jsxs(f, { ...j, children: [
    /* @__PURE__ */ r.jsx(
      z,
      {
        spacing: 2,
        templateColumns: ["repeat(2, 1fr)", "repeat(auto-fill, minmax(200px, 1fr))"],
        children: t == null ? void 0 : t.map((i, o) => {
          var x;
          return o < n ? /* @__PURE__ */ r.jsx("center", { children: /* @__PURE__ */ r.jsxs(
            A,
            {
              size: "sm",
              borderWidth: ((i == null ? void 0 : i.familyName) === (e == null ? void 0 : e.familyName), "1px"),
              borderColor: (i == null ? void 0 : i.familyName) === (e == null ? void 0 : e.familyName) ? "black" : "#A5AAAF",
              borderRadius: "8px",
              onClick: () => {
                (i == null ? void 0 : i.familyName) === (e == null ? void 0 : e.familyName) && !g || m && m(i);
              },
              style: {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "220px",
                cursor: "pointer"
              },
              children: [
                (i == null ? void 0 : i.familyName) === (e == null ? void 0 : e.familyName) && /* @__PURE__ */ r.jsx(
                  f,
                  {
                    position: "absolute",
                    top: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    right: 0,
                    bg: "white",
                    color: "black",
                    fontWeight: "bold",
                    borderColor: "black",
                    borderWidth: "1px",
                    zIndex: 2,
                    paddingX: "8px",
                    paddingY: "2px",
                    width: "max-content",
                    fontSize: "12px",
                    textAlign: "center",
                    borderRadius: "4px",
                    children: /* @__PURE__ */ r.jsx(
                      d,
                      {
                        text: "Your current model",
                        translationKey: `${s}/currentModel`
                      }
                    )
                  }
                ),
                /* @__PURE__ */ r.jsx(C, { paddingTop: "15px", children: /* @__PURE__ */ r.jsx(
                  S,
                  {
                    src: i.img,
                    alt: "loading",
                    height: "100px",
                    width: "80px"
                  }
                ) }),
                /* @__PURE__ */ r.jsxs(w, { paddingBottom: "4px", children: [
                  /* @__PURE__ */ r.jsx(h, { fontWeight: "bold", fontSize: "15px", children: (x = u(i == null ? void 0 : i.familyName.toLowerCase())) == null ? void 0 : x.replace(
                    /iphone/gi,
                    "iPhone"
                  ) }),
                  /* @__PURE__ */ r.jsx(
                    h,
                    {
                      fontWeight: "light",
                      fontSize: "15px",
                      marginTop: "4px",
                      children: i.srf
                    }
                  )
                ] })
              ]
            }
          ) }, o) : null;
        })
      }
    ),
    n < (t == null ? void 0 : t.length) && /* @__PURE__ */ r.jsx("center", { children: /* @__PURE__ */ r.jsx(
      T,
      {
        mt: "4",
        onClick: N,
        display: "flex",
        justifyContent: "center",
        color: p == null ? void 0 : p.primary,
        variant: "outline",
        paddingX: "12px",
        children: /* @__PURE__ */ r.jsx(
          d,
          {
            text: "Load more options",
            translationKey: `${s}/btnLoadMore`
          }
        )
      }
    ) })
  ] });
};
export {
  ii as Cards
};
